import React from 'react'

export function ForestDruid({ className = '', pose = 'idle' }) {
  return (
    <svg
      viewBox="0 0 200 300"
      className={`w-full h-full ${className}`}
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <linearGradient id="fd-robeGrad" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="#14532d" />
          <stop offset="100%" stopColor="#064e3b" />
        </linearGradient>
        <linearGradient id="fd-woodGrad" x1="0" y1="0" x2="1" y2="0">
          <stop offset="0%" stopColor="#78350f" />
          <stop offset="50%" stopColor="#b45309" />
          <stop offset="100%" stopColor="#78350f" />
        </linearGradient>
        <filter id="fd-natureGlow" x="-50%" y="-50%" width="200%" height="200%">
          <feGaussianBlur stdDeviation="5" result="blur" />
          <feMerge>
            <feMergeNode in="blur" />
            <feMergeNode in="SourceGraphic" />
          </feMerge>
        </filter>
        <filter id="fd-blastGlow" x="-50%" y="-50%" width="200%" height="200%">
          <feGaussianBlur stdDeviation="10" result="blur" />
          <feMerge>
            <feMergeNode in="blur" />
            <feMergeNode in="SourceGraphic" />
          </feMerge>
        </filter>
      </defs>

      <style>
        {`
          @keyframes fd-float {
            0%, 100% { transform: translateY(0); }
            50% { transform: translateY(-10px); }
          }
          @keyframes fd-leafSwirl {
            0% { transform: translateY(0) rotate(0deg) translateX(0); opacity: 0; }
            20% { opacity: 1; }
            80% { opacity: 1; }
            100% { transform: translateY(-100px) rotate(360deg) translateX(30px); opacity: 0; }
          }
          @keyframes fd-orbPulse {
            0%, 100% { transform: scale(1); opacity: 0.8; }
            50% { transform: scale(1.2); opacity: 1; }
          }
          @keyframes fd-blast {
            0%, 100% { transform: scaleX(0.9); opacity: 0.8; }
            50% { transform: scaleX(1.1); opacity: 1; }
          }
          @keyframes fd-tornado {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
          @keyframes fd-stumble {
            0%, 100% { transform: rotate(5deg); }
            50% { transform: rotate(8deg); }
          }
          @keyframes fd-grow {
            0% { transform: scaleY(0.9); }
            50% { transform: scaleY(1.05); }
            100% { transform: scaleY(0.9); }
          }
          
          .fd-idle-anim { animation: fd-float 5s ease-in-out infinite; }
          .fd-leaf { animation: fd-leafSwirl 4s linear infinite; }
          .fd-orb-anim { animation: fd-orbPulse 3s ease-in-out infinite; transform-origin: center; }
          .fd-attack-anim { animation: fd-blast 0.2s infinite; transform-origin: left center; }
          .fd-jump-anim { animation: fd-float 3s ease-in-out infinite; }
          .fd-tornado-anim { animation: fd-tornado 2s linear infinite; transform-origin: center; }
          .fd-hurt-anim { animation: fd-stumble 1s ease-in-out infinite; transform-origin: bottom center; }
          .fd-block-anim { animation: fd-grow 3s ease-in-out infinite; transform-origin: bottom center; }
        `}
      </style>

      {pose === 'idle' && (
        <g className="fd-idle-anim">
          <g fill="#84cc16" opacity="0.8">
            <path
              d="M40 250 Q 45 245 50 250 Q 45 255 40 250"
              className="fd-leaf"
              style={{ animationDelay: '0s' }}
            />
            <path
              d="M160 220 Q 165 215 170 220 Q 165 225 160 220"
              className="fd-leaf"
              style={{ animationDelay: '1.2s' }}
            />
            <path
              d="M70 180 Q 75 175 80 180 Q 75 185 70 180"
              className="fd-leaf"
              style={{ animationDelay: '2.5s' }}
            />
          </g>
          <path
            d="M120 100 Q 150 140 140 180 L 120 170 Z"
            fill="url(#fd-robeGrad)"
          />
          <path
            d="M80 80 L120 80 Q 150 180 140 260 L 60 260 Q 50 180 80 80 Z"
            fill="url(#fd-robeGrad)"
          />
          <path
            d="M90 80 Q 110 180 100 260"
            stroke="#065f46"
            strokeWidth="4"
            fill="none"
          />
          <path
            d="M110 80 Q 130 180 120 260"
            stroke="#065f46"
            strokeWidth="4"
            fill="none"
          />
          <path d="M75 100 L125 100 L120 110 L80 110 Z" fill="#facc15" />
          <path d="M65 240 L135 240 L140 250 L60 250 Z" fill="#facc15" />
          <path
            d="M80 90 Q 50 130 60 160 L 80 150 Z"
            fill="url(#fd-robeGrad)"
          />
          <circle cx="65" cy="160" r="8" fill="#fcd34d" />
          <g transform="translate(50, 40)">
            <rect
              x="10"
              y="20"
              width="8"
              height="220"
              rx="4"
              fill="url(#fd-woodGrad)"
            />
            <path
              d="M10 50 Q 0 70 18 90 T 10 130 T 18 170"
              stroke="#4ade80"
              strokeWidth="3"
              fill="none"
            />
            <path
              d="M5 20 Q 14 0 23 20 Q 14 40 5 20 Z"
              fill="url(#fd-woodGrad)"
            />
            <circle
              cx="14"
              cy="20"
              r="12"
              fill="#a3e635"
              filter="url(#fd-natureGlow)"
              className="fd-orb-anim"
            />
            <circle cx="14" cy="20" r="6" fill="#ffffff" />
          </g>
          <g transform="translate(100, 60)">
            <path
              d="M-25 0 Q 0 -40 25 0 L 30 30 L -30 30 Z"
              fill="url(#fd-robeGrad)"
            />
            <circle cx="0" cy="5" r="15" fill="#022c22" />
            <circle
              cx="-6"
              cy="2"
              r="3"
              fill="#a3e635"
              filter="url(#fd-natureGlow)"
            />
            <circle
              cx="6"
              cy="2"
              r="3"
              fill="#a3e635"
              filter="url(#fd-natureGlow)"
            />
            <path
              d="M-15 -10 Q -30 -30 -40 -50 M-30 -30 L -45 -25 M-35 -40 L -20 -45"
              stroke="url(#fd-woodGrad)"
              strokeWidth="4"
              strokeLinecap="round"
              fill="none"
            />
            <path
              d="M15 -10 Q 30 -30 40 -50 M30 -30 L 45 -25 M35 -40 L 20 -45"
              stroke="url(#fd-woodGrad)"
              strokeWidth="4"
              strokeLinecap="round"
              fill="none"
            />
          </g>
        </g>
      )}

      {pose === 'attack' && (
        <g>
          {/* Leaning forward */}
          <g transform="translate(-20, 20) rotate(10)">
            <path
              d="M80 80 L120 80 Q 150 180 140 260 L 60 260 Q 50 180 80 80 Z"
              fill="url(#fd-robeGrad)"
            />
            <path d="M75 100 L125 100 L120 110 L80 110 Z" fill="#facc15" />

            {/* Head forward */}
            <g transform="translate(110, 60) rotate(15)">
              <path
                d="M-25 0 Q 0 -40 25 0 L 30 30 L -30 30 Z"
                fill="url(#fd-robeGrad)"
              />
              <circle cx="0" cy="5" r="15" fill="#022c22" />
              <circle
                cx="-2"
                cy="2"
                r="4"
                fill="#a3e635"
                filter="url(#fd-natureGlow)"
              />
              <circle
                cx="10"
                cy="2"
                r="4"
                fill="#a3e635"
                filter="url(#fd-natureGlow)"
              />
              <path
                d="M-15 -10 Q -30 -30 -40 -50"
                stroke="url(#fd-woodGrad)"
                strokeWidth="4"
                fill="none"
              />
              <path
                d="M15 -10 Q 30 -30 40 -50"
                stroke="url(#fd-woodGrad)"
                strokeWidth="4"
                fill="none"
              />
            </g>

            {/* Arm extended with staff */}
            <path
              d="M80 90 Q 120 100 150 120 L 140 140 Z"
              fill="url(#fd-robeGrad)"
            />

            <g transform="translate(140, 100) rotate(60)">
              <rect
                x="10"
                y="-100"
                width="8"
                height="220"
                rx="4"
                fill="url(#fd-woodGrad)"
              />
              <path
                d="M5 -100 Q 14 -120 23 -100 Q 14 -80 5 -100 Z"
                fill="url(#fd-woodGrad)"
              />
              <circle
                cx="14"
                cy="-100"
                r="15"
                fill="#a3e635"
                filter="url(#fd-natureGlow)"
              />
            </g>
          </g>

          {/* Massive Energy Blast */}
          <g transform="translate(130, 110)" className="fd-attack-anim">
            <path
              d="M0 -20 L100 -40 L120 0 L100 40 L0 20 Z"
              fill="#a3e635"
              filter="url(#fd-blastGlow)"
              opacity="0.8"
            />
            <path
              d="M0 -10 L80 -20 L100 0 L80 20 L0 10 Z"
              fill="#ffffff"
              filter="url(#fd-blastGlow)"
            />
            {/* Swirling leaves in blast */}
            <path
              d="M20 -10 Q 40 -30 60 0 T 100 -10"
              stroke="#4ade80"
              strokeWidth="2"
              fill="none"
            />
            <path
              d="M20 10 Q 40 30 60 0 T 100 10"
              stroke="#4ade80"
              strokeWidth="2"
              fill="none"
            />
          </g>

          {/* Ground Vines */}
          <path
            d="M100 280 Q 150 250 200 270"
            stroke="#166534"
            strokeWidth="8"
            fill="none"
          />
          <path
            d="M120 280 Q 160 240 180 280"
            stroke="#15803d"
            strokeWidth="6"
            fill="none"
          />
        </g>
      )}

      {pose === 'jump' && (
        <g className="fd-jump-anim">
          {/* Leaf Tornado Base */}
          <g transform="translate(100, 250)" className="fd-tornado-anim">
            <ellipse
              cx="0"
              cy="0"
              rx="40"
              ry="10"
              fill="none"
              stroke="#84cc16"
              strokeWidth="4"
              opacity="0.5"
            />
            <ellipse
              cx="0"
              cy="-20"
              rx="60"
              ry="15"
              fill="none"
              stroke="#84cc16"
              strokeWidth="4"
              opacity="0.5"
            />
            <ellipse
              cx="0"
              cy="-40"
              rx="80"
              ry="20"
              fill="none"
              stroke="#84cc16"
              strokeWidth="4"
              opacity="0.5"
            />
            {/* Leaves in tornado */}
            <circle cx="-40" cy="-20" r="3" fill="#4ade80" />
            <circle cx="50" cy="-30" r="4" fill="#4ade80" />
            <circle cx="-60" cy="-40" r="3" fill="#4ade80" />
            <circle cx="70" cy="-10" r="5" fill="#4ade80" />
          </g>

          {/* Billowing Robes */}
          <path
            d="M80 60 L120 60 Q 180 160 160 220 L 40 220 Q 20 160 80 60 Z"
            fill="url(#fd-robeGrad)"
          />
          <path d="M75 80 L125 80 L120 90 L80 90 Z" fill="#facc15" />

          {/* Arms raised */}
          <path d="M80 70 Q 30 50 20 80 L 40 100 Z" fill="url(#fd-robeGrad)" />
          <path
            d="M120 70 Q 170 50 180 80 L 160 100 Z"
            fill="url(#fd-robeGrad)"
          />

          {/* Staff held horizontally */}
          <g transform="translate(100, 40) rotate(90)">
            <rect
              x="10"
              y="-80"
              width="8"
              height="160"
              rx="4"
              fill="url(#fd-woodGrad)"
            />
            <circle
              cx="14"
              cy="-80"
              r="15"
              fill="#a3e635"
              filter="url(#fd-natureGlow)"
              className="fd-orb-anim"
            />
            <circle cx="14" cy="-80" r="8" fill="#ffffff" />
          </g>

          {/* Head looking down */}
          <g transform="translate(100, 50) rotate(10)">
            <path
              d="M-25 0 Q 0 -40 25 0 L 30 30 L -30 30 Z"
              fill="url(#fd-robeGrad)"
            />
            <circle cx="0" cy="10" r="15" fill="#022c22" />
            <circle
              cx="-6"
              cy="15"
              r="3"
              fill="#a3e635"
              filter="url(#fd-natureGlow)"
            />
            <circle
              cx="6"
              cy="15"
              r="3"
              fill="#a3e635"
              filter="url(#fd-natureGlow)"
            />
            <path
              d="M-15 -10 Q -30 -30 -40 -50"
              stroke="url(#fd-woodGrad)"
              strokeWidth="4"
              fill="none"
            />
            <path
              d="M15 -10 Q 30 -30 40 -50"
              stroke="url(#fd-woodGrad)"
              strokeWidth="4"
              fill="none"
            />
          </g>
        </g>
      )}

      {pose === 'hurt' && (
        <g className="fd-hurt-anim">
          {/* Falling leaves */}
          <g fill="#4d7c0f">
            <path d="M40 150 Q 45 145 50 150" />
            <path d="M160 120 Q 165 115 170 120" />
            <path d="M70 280 Q 75 275 80 280" />
          </g>

          {/* Stumbling Robes */}
          <path
            d="M90 80 L130 90 Q 170 180 150 260 L 70 250 Q 50 180 90 80 Z"
            fill="url(#fd-robeGrad)"
          />

          {/* Dropped Staff */}
          <g transform="translate(160, 200) rotate(45)">
            <rect
              x="0"
              y="0"
              width="8"
              height="150"
              rx="4"
              fill="url(#fd-woodGrad)"
            />
            <circle cx="4" cy="0" r="8" fill="#4ade80" opacity="0.5" />
          </g>

          {/* Head thrown back, cracked antler */}
          <g transform="translate(120, 60) rotate(25)">
            <path
              d="M-25 0 Q 0 -40 25 0 L 30 30 L -30 30 Z"
              fill="url(#fd-robeGrad)"
            />
            <circle cx="0" cy="5" r="15" fill="#022c22" />
            {/* Dim eyes */}
            <circle cx="-6" cy="2" r="2" fill="#a3e635" opacity="0.3" />
            <circle cx="6" cy="2" r="2" fill="#a3e635" opacity="0.3" />
            {/* Broken antler */}
            <path
              d="M-15 -10 L -25 -20"
              stroke="url(#fd-woodGrad)"
              strokeWidth="4"
              fill="none"
            />
            <path
              d="M15 -10 Q 30 -30 40 -50"
              stroke="url(#fd-woodGrad)"
              strokeWidth="4"
              fill="none"
            />
          </g>

          {/* Arms flailing */}
          <path
            d="M90 90 Q 40 100 30 140 L 50 150 Z"
            fill="url(#fd-robeGrad)"
          />
        </g>
      )}

      {pose === 'block' && (
        <g className="fd-block-anim">
          {/* Staff planted */}
          <g transform="translate(100, 80)">
            <rect
              x="-4"
              y="0"
              width="8"
              height="200"
              rx="4"
              fill="url(#fd-woodGrad)"
            />
            <circle
              cx="0"
              cy="0"
              r="15"
              fill="#a3e635"
              filter="url(#fd-natureGlow)"
            />
          </g>

          {/* Druid crouched behind */}
          <path
            d="M70 150 L130 150 Q 150 220 140 280 L 60 280 Q 50 220 70 150 Z"
            fill="url(#fd-robeGrad)"
          />
          <g transform="translate(100, 130)">
            <path
              d="M-25 0 Q 0 -40 25 0 L 30 30 L -30 30 Z"
              fill="url(#fd-robeGrad)"
            />
            <circle cx="0" cy="5" r="15" fill="#022c22" />
            <circle
              cx="-6"
              cy="2"
              r="3"
              fill="#a3e635"
              filter="url(#fd-natureGlow)"
            />
            <circle
              cx="6"
              cy="2"
              r="3"
              fill="#a3e635"
              filter="url(#fd-natureGlow)"
            />
          </g>

          {/* Massive Vine Wall */}
          <g strokeLinecap="round" fill="none">
            <path
              d="M20 280 Q 40 150 100 100"
              stroke="#14532d"
              strokeWidth="15"
            />
            <path
              d="M180 280 Q 160 150 100 100"
              stroke="#166534"
              strokeWidth="12"
            />
            <path
              d="M50 280 Q 70 180 100 120"
              stroke="#15803d"
              strokeWidth="10"
            />
            <path
              d="M150 280 Q 130 180 100 120"
              stroke="#22c55e"
              strokeWidth="8"
            />
            <path
              d="M80 280 Q 90 200 100 150"
              stroke="#4ade80"
              strokeWidth="5"
            />
          </g>

          {/* Leaf Canopy */}
          <path
            d="M40 120 Q 100 60 160 120 Q 100 140 40 120 Z"
            fill="#15803d"
            opacity="0.9"
          />
          <path
            d="M60 100 Q 100 50 140 100 Q 100 120 60 100 Z"
            fill="#22c55e"
            opacity="0.9"
          />
        </g>
      )}
    </svg>
  )
}
